import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { listContinents } from "@/js/lists.ts";
import { getClientAppData } from "@/js/http/auth";
import WarehousePopin from "@/components/warehouse/WarehousePopin.vue";
import WarehouseComponent from "@/components/warehouse/WarehouseComponent.vue";
export default {
  name: "WarehouseSelect",
  props: {
    warehouses: Array,
    selected: Number,
    rules: Array,
    required: Boolean,
    disabled: Boolean,
    clearable: Boolean,
    displayAddressBelow: Boolean,
    label: {
      type: String,
      default: "Warehouse"
    },
    hideSelected: Boolean,
    isInboundForced: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WarehousePopin: WarehousePopin,
    WarehouseComponent: WarehouseComponent
  },
  data: function data() {
    return {
      clientAppData: null,
      model: {
        id_warehouse: null,
        name: null
      },
      warehousePopinShown: true,
      countries: [],
      states: []
    };
  },
  created: function created() {
    var _this2 = this;
    this.clientAppData = getClientAppData(this);
    if (this.selected) {
      this.model = this.warehouses.find(function (x) {
        return x.id_warehouse == _this2.selected;
      });
    } else {
      this.model = null;
    }
    var _this = this;
    request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
      _this.countries = _toConsumableArray(response.data.countries);
      _this.states = _toConsumableArray(response.data.states);
    }).catch(function (err) {
      _this.$toasted.show("An error occured. Please contact an administrator.", {
        type: "error"
      });
    });
  },
  methods: {
    changeWarehouse: function changeWarehouse(item) {
      this.$emit("changeWarehouse", item ? item.id_warehouse : null);
    },
    openEditWarehousePopin: function openEditWarehousePopin(item) {
      var _this3 = this;
      this.warehousePopinShown = true;
      this.$nextTick(function () {
        _this3.$refs.warehousePopin.openEdit(item);
      });
    },
    openNewWarehousePopin: function openNewWarehousePopin() {
      var _this4 = this;
      this.warehousePopinShown = true;
      this.$nextTick(function () {
        _this4.$refs.warehousePopin.open();
      });
    },
    closeWarehousePopin: function closeWarehousePopin(response) {
      if (response.confirmed) {
        this.fetchWarehouses(response.data);
      }
      this.warehousePopinShown = false;
    },
    fetchWarehouses: function fetchWarehouses(idWarehouse) {
      this.$emit("fetchWarehouses", idWarehouse);
    },
    updateModel: function updateModel(idWarehouse) {
      this.model = this.warehouses.find(function (x) {
        return x.id_warehouse == idWarehouse;
      });
    },
    getContinentNameFromIso: function getContinentNameFromIso(item) {
      var _this5 = this;
      var displayName = [];
      item.defaultDepartures.forEach(function (departure) {
        var departureName = listContinents.find(function (x) {
          return x.id === departure.continentIso2;
        }).display_name;
        if (departure.stateId) {
          departureName = _this5.states.find(function (x) {
            return x.id_state == departure.stateId;
          }).state_label;
        } else if (departure.countryId) {
          departureName = _this5.countries.find(function (x) {
            return x.id_country === departure.countryId;
          }).printable_name;
        }
        displayName.push(departureName);
      });
      return displayName.join(" / ");
    }
  }
};